/* eslint-disable no-unused-expressions */
import styled from 'styled-components'
import React, { Fragment } from 'react'
import { bool, func } from 'prop-types'
import { empty, handleKeyPressNumber } from '../../utils/helpers/helpers'
import Textbox from '@taglivros/oef_componentes/build/components/textbox'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import Input from '@taglivros/oef_componentes/build/components/input'

import { TITULO, BOTAO_CONFIRMAR } from './constantsCVVInput'
import { CVV_INVALIDO, REQUIRED_MESSAGE } from '../CartaoCreditoForm/constantsCartaoCredito'

const Texto = styled.p`
  ${StyleGuide.tipografia.textoPequeno};
  margin: 15px 0;
`

const Wrapper = styled.div`
  align-items: baseline;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  position: relative;
  white-space: nowrap;
  /* width: 50%; */

  ${( { isCenter } ) => isCenter && `margin: 0 auto`};

  @media ( max-width: ${StyleGuide.mediaQuery.mobile} ){
    width: 100%;
  }

  label {
    color: ${StyleGuide.cores.cinza500};
    opacity: 0.4;
    z-index: 0;
  }

  & button {
    width: auto;
  }
`

const CVVInput = ( { botao, isCenter, handleCVV, titulo } ) => {
  const [ cartaoCredito, setCartaoCredito ] = React.useState( {
    'cvv': '',
    'erro': null
  } )
  const [ erro, setErro ] = React.useState( false )
  const [ sucesso, setSucesso ] = React.useState( false )

  const handleCVVBlur = ( event ) => {
    if ( empty( event.target.value ) ) {
      return setErro( {
        ...erro,
        [ event.target.name ]: REQUIRED_MESSAGE
      } )
    }

    if ( cartaoCredito.cvv.length < 3 ) {
      return setErro( {
        ...erro,
        'cvv': CVV_INVALIDO
      } )
    }

    setErro( false )
    setSucesso( true )

    if ( handleCVV ) {
      handleCVV( {
        'numeroCVV': event.target.value,
        'valido': true
      } )
    }
  }

  const handleChange = ( event ) => {
    const { name, value } = event.target
    event.target.value = value.substring( 0, 4 )

    setCartaoCredito( {
      ...cartaoCredito,
      [ name ]: value
    } )

    sucesso && setSucesso( false )
    erro && setErro( false )
    if ( handleCVV ) {
      handleCVV( {
        'numeroCVV': null,
        'valido': event.target.value.length >= 3
      } )
    }
  }

  const handleKeyPress = event => {
    handleKeyPressNumber( event )
    const { value } = event.target
    if ( value.length >= 4 ) {
      return event.preventDefault()
    }
  }

  return (
    <Fragment>
      { titulo ?
        <Texto>
          { TITULO }
        </Texto> : null}

      <Wrapper
        className="campo-cvv"
        isCenter={ isCenter }
        key="input-cupons"
        sucesso={ sucesso }
      >
        { !botao ?
          <Input
            erro={ erro.cvv }
            fieldName="cvv"
            label="CVV"
            name="cvv"
            onBlur={ handleCVVBlur }
            onChange={ handleChange }
            onKeyPress={ handleKeyPress }
            sucesso={ sucesso }
            type="text"
            value={ cartaoCredito.cvv }
          /> :
          <Textbox
            buttonValue={ BOTAO_CONFIRMAR }
            erro={ erro.cvv }
            label="CVV"
            name="cvv"
            onBlur={ handleCVVBlur }
            onChange={ handleChange }
            onClick={ handleCVVBlur }
            onKeyPress={ handleKeyPress }
            onPressEnter={ handleCVVBlur }
            sucesso={ sucesso }
            tipo="text"
            value={ cartaoCredito.cvv }
          />}
      </Wrapper>
    </Fragment>
  )
}

CVVInput.propTypes = {
  'botao': bool,
  'handleCVV': func,
  'isCenter': bool,
  'titulo': bool
}

CVVInput.defaultProps = {
  'botao': true,
  'handleCVV': null,
  'isCenter': false,
  'titulo': true
}

export default CVVInput
